export default __webpack_public_path__ + "static/media/sentiment_happy.2a974518.svg";